import styled from "styled-components";
import { StyledDocumentTitle } from "../styles/styledTextDocument";

export const StyledServiceDetailsWrapper = styled.div`
  .services-details-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, max-content) );
    grid-gap: 15px;

    button {
      height: 55px;
    }
  }

  .services-details__client-list-head {
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
  
  .services-details__actions {
    padding: 0 0 20px;
    display: grid;
    grid-template-columns: repeat(2, max-content);
    grid-gap: 15px;
  }
`;

export const StyledConnectionList = styled.div`
  ${StyledDocumentTitle} {
    padding: 0 0 15px;
  }

  .connections {
    &__row {
      padding: 10px 0;
      display: grid;
      grid-template-columns: 1fr 40px;
      
      &:not(:last-child) {
        border-bottom: 1px solid #E5E5E5;
      }
    }
    
    &__project {
      color: #162954;
      font-weight: 600;
    }
    &__name {
      font-size: 14px;
    }
    
    &__client {
      color: #909090;
      font-size: 12px;
    }
  }
  
  button {
    min-width: auto;
    width: 40px;
    padding: 0;
  }

  button[border="danger"] {
    color: #fc344a;
  }
`;

export const StyledBalanceList = styled.div`
  max-height: calc(100vh - 480px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
    background-color: #CEEBE4;
    border-radius: 20px;
  }
  &::-webkit-scrollbar-track{
    background-color: #CEEBE4;
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb {
    width: 12px;
    border: 2px solid #CEEBE4;
    background: linear-gradient(40deg, #29DEAE -20.66%, #277661 68.48%);
    border-radius: 12px;
  }

  .balances {
    &__row {
      padding: 5px 0 5px 10px;
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 40px;
      cursor: pointer;

      &:hover {
        color: #277661;
        background-color: #F5F4FA;
      }

      &:not(:last-child) {
        border-bottom: 1px solid #E5E5E5;
      }
    }

    &_active {
      background-color: #e9f3f0;
    }
  }
`;